export default __webpack_public_path__ + "static/media/tem_no_parque3.3aa22b16.jpg";